import React from 'react';

const About = () => {
    return (
        <div>
            <h2>This is about</h2>
        </div>
    );
};

export default About;